import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import FastClick from './fastclick';
import Es6Promise from 'es6-promise';
import injectTapEventPlugin from 'react-tap-event-plugin';
import VConsole from 'vconsole'
// import boot from './util/boot'

injectTapEventPlugin();

Es6Promise.polyfill();

// Array polyfill
if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

// Object polyfill
if (!Object.keys) {
  Object.keys = function(obj) {
    if (this == null) {
      throw new TypeError('Object.keys called on null or undefined');
    }
    if (typeof obj !== 'object') {
      throw new TypeError('obj must be a object');
    }
    var keys = [];
    for(var pro in obj){
      keys.push(pro);
    }
    return keys;
  };
}
if (!Object.values) {
  Object.values = function(obj) {
    if (this == null) {
      throw new TypeError('Object.values called on null or undefined');
    }
    if (typeof obj !== 'object') {
      throw new TypeError('obj must be a object');
    }
    var values = [];
    for(var pro in obj){
      values.push(obj[pro]);
    }
    return values;
  };
}

FastClick();

if (window.location.search.indexOf('debug=true') != -1) {
    new VConsole();
}
  let node = document.getElementById('app');
  ReactDOM.render(<App/>, node, ()=> {
    document.addEventListener('click', function(e) {
      if (e.target.closest('.j-reset')){
        ReactDOM.unmountComponentAtNode(node);
        ReactDOM.render(<App/>, node);
      };
    }, false);
  });

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js